@if (drilldownDisplay === 'chart') {
<div class="survey-drilldown-panel" [ngClass]="containerClass">

  <div [hidden]="chartLevel !== 0">
    <app-chart
      [chartSchema]="internalChartSchema"
      [chartType]="chartType"
      [infoFields]="infoFields"
      [elementId]="elementId"
      [containerClass]="containerClass"
      [apiConfig]="apiConfig"
      [exportConfig]="null"
      [dataTransform]="internalDataTransform"
      [dataInput]="dataInput"
      [onLoadFetch]="onLoadFetch">
    </app-chart>
  </div>
  @if (chartLevel === 1) {
    <app-chart
      [chartSchema]="level1Schema"
      chartType="column"
      [elementId]="elementId + '-level1'"
      [containerClass]="containerClass"
      [exportConfig]="null"
      [dataInput]="level1Data"
      [onLoadFetch]="false">
    </app-chart>
  }
</div>
} @else {
<div class="survey-chart-export-wrapper" [hidden]="showDrilldown">
  <app-chart
    [chartSchema]="internalChartSchema"
    [chartType]="chartType"
    [infoFields]="infoFields"
    [elementId]="elementId"
    [containerClass]="containerClass"
    [apiConfig]="apiConfig"
    [exportConfig]="null"
    [dataTransform]="internalDataTransform"
    [dataInput]="dataInput"
    [onLoadFetch]="onLoadFetch">
  </app-chart>
  @if (exportConfig) {
    <div class="survey-chart-export-action">
      <app-download-button [tableValues]="currentLevelExportRows" (buttonClicked)="exportCurrentLevel()"
        exportMessage="{{exportConfig.exportMessage}}"></app-download-button>
    </div>
  }
</div>
@if (showDrilldown) {
  <div class="chart-drilldown" [ngClass]="containerClass">
    <button type="button" class="chart-drilldown-back" (click)="goBack()">&larr; Back</button>
    <filter-list-container
      [DataTableSchema]="drilldownSchema"
      [filterSchema]="drilldownFilterSchema"
      [elementId]="elementId + '-drilldown'"
      [forSection]="true"
      [onLoadFetch]="false">
    </filter-list-container>
  </div>
}
}
